import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { errorLog, warnLog } from '@bitComponents/utils/logUtils';
import CustomLink from '@bitComponents/unifiedComponents/CustomLink';
import { setUpPropsByDevice } from '@bitComponents/utils/common';
import { BUTTON_CONTENT } from '@bitComponents/utils/tagging';
import Spin from './Spin';
import './button.scss';

const COMPONENT_NAME = 'Button';

export const BUTTON_COLOR = {
  BLUE: 'blue',
  BLUE_REVERSE: 'blue_reverse',
  WHITE_BLUE: 'white_blue',
  WHITE_REVERSE: 'white_reverse',
  ORCHID: 'orchid',
  ORCHID_LIGHT: 'orchid-light',
  ORCHID_DARK: 'orchid-dark',
  CORAL: 'coral',
  CORAL_LIGHT: 'coral-light',
  CORAL_DARK: 'coral-dark',
  TURQUOISE: 'turquoise',
  TURQUOISE_LIGHT: 'turquoise-light',
  TURQUOISE_DARK: 'turquoise-dark',
  AMBAR: 'ambar',
  AMBAR_LIGHT: 'ambar-light',
  AMBAR_DARK: 'ambar-dark',
  GREEN: 'green',
  GREEN_LIGHT: 'green-light',
  GREEN_DARK: 'green-dark',
  PURPLE: 'purple',
  PURPLE_LIGHT: 'purple-light',
  PURPLE_DARK: 'purple-dark',
  NAVY: 'navy',
  NAVY_LIGHT: 'navy-light',
  NAVY_DARK: 'navy-dark',
  GREY: 'grey',
  GREY_REVERSE: 'grey_reverse',
  GREY1: 'grey1',
  GREY3: 'grey3',
  GREY5: 'grey5',
  GREY7: 'grey7',
  GREY_REVERSE3: 'grey_reverse3',
  GREY_REVERSE5: 'grey_reverse5',
  GREY_REVERSE9: 'grey_reverse9',
  WHITE: 'white',
  GREEN_MEDIUM: 'green_medium',
  GREEN_REVERSE: 'green_reverse',
  BLUE_LIGHT: 'blue_light',
  BLUE_DARK: 'blue_dark',
  BLUE_DARK_REVERSE: 'blue_dark_reverse',
  RED: 'red',
  RED_REVERSE: 'red_reverse',
  HEADER: 'header',
  HEADER_REVERSE: 'header_reverse',
  HEADER_DIFFERENTIATED: 'header_differentiated',
  ORANGE: 'orange',
};

export const BUTTON_FONT = {
  REGULAR_FONT: 'regular',
  BOLD_FONT: 'bold',
  LIGHT_FONT: 'light',
};

export const BUTTON_TEXT_TRANSFORM = {
  INITIAL: 'initial',
  UPPERCASE: 'uppercase',
};

export const BUTTON_LETTER_SPACING = {
  DEFAULT: 'default',
  EMP: 'emp',
};

export const BUTTON_WIDTH = {
  SHORT: 'short',
  DOUBLE: 'double',
  MEDIUM: 'medium',
  LARGE: 'large',
  LIQUID: 'liquid',
  LIQUID_DOPPED: 'liquid_dopped',
  FULL: 'full',
};

export const BUTTON_HEIGHT = {
  EXTRALARGE: 'extra-large',
  LARGE: 'large', // 48
  REGULAR: 'regular', // 43
  MEDIUM: 'medium', // 32
  SMALL: 'small', // 30
};

export const LABEL_SIZE = {
  DEPENDS_SIZE_SELECTED: 'depends_size_selected',
  LARGE: 'large', // 48
  REGULAR: 'regular', // 18px font size
  MEDIUM: 'medium', // 16px font size
  SMALL: 'small', // 14px font size
};

export const BUTTON_OPERATION = {
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILURE: 'failure',
  NO: 'no',
};

export const ICON_POSITION = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const SEGMENT = {
  PARTICULARES: 'particulares',
  EMPRESAS: 'empresas',
  GP: 'gp',
  EMP: 'emp',
};

export const BORDER_RADIUS = {
  NONE: 'none',
  SMALL: 'small',
};

export const convertToOptions = (optionsObject) => {
  const keys = Object.keys(optionsObject);
  return keys.map((key) => {
    return optionsObject[key];
  });
};

export const BUTTON_OPERATION_KEYS = Object.keys(BUTTON_OPERATION);

class Button extends PureComponent {
  setLabelAnimation = (operation) => {
    if (operation === BUTTON_OPERATION.NO) {
      return 'show';
    }
    if (operation === BUTTON_OPERATION.LOADING) {
      return 'hidden';
    }
    return 'fade';
  };

  buttonSizeCss = (size, segment) => {
    let { w, h } = size;
    if (!w) {
      w = BUTTON_WIDTH.MEDIUM;
    }
    if (!h) {
      h = BUTTON_HEIGHT.REGULAR;
    }
    return ` buttonNew_width--${w} buttonNew_height--${h}-${segment}`;
  };

  // when prop is not defined
  setLabelSizeCss = (size) => {
    return ` buttonNew_label--${size}`;
  };

  handleMouseDown = (event) => {
    const { onClick } = this.props;
    const e = event;
    if (e.button === 1) {
      if (onClick) {
        onClick();
        return true;
      }
    }
    return false;
  };

  getSegment = () => {
    let { segment } = this.props;
    /* TRANSFORM segment when PARTICULARES OR EMPRESAS */
    switch (segment) {
      case 'empresas':
      case 'emp':
        segment = 'emp';
        break;
      case 'particulares':
      default:
        segment = 'gp';
        break;
    }
    return segment;
  };

  renderButtonContent = (props) => {
    const {
      svgComponent,
      size,
      label,
      labelSize,
      iconPosition,
      operation,
      color,
    } = props;
    /* check if size has w and  */
    const mySize = {
      w: BUTTON_WIDTH.MEDIUM,
      h: BUTTON_HEIGHT.REGULAR,
      ...size,
    };

    /* APPEARANCE */
    let labelSizeCss = this.setLabelSizeCss(mySize.h);
    if (labelSize && labelSize !== LABEL_SIZE.DEPENDS_SIZE_SELECTED) {
      labelSizeCss = this.setLabelSizeCss(labelSize);
    }
    const labelAnimationClass = this.setLabelAnimation(operation);
    let newSvgComponent = null;

    if (svgComponent) {
      newSvgComponent = React.cloneElement(svgComponent, {
        className: 'buttonNew_content-icon',
      });
    }
    const segment = this.getSegment();

    const operationIsVisible = operation && operation !== BUTTON_OPERATION.NO;

    let buttonContentCsss = 'buttonNew_content';
    if (operationIsVisible) {
      buttonContentCsss += ' operation';
    }
    let buttonFlexJustify = 'buttonNew_label__Wrapper--center';
    if (newSvgComponent) {
      buttonFlexJustify = 'buttonNew_label__Wrapper--between';
    }

    return (
      <span className={buttonContentCsss}>
        {!operationIsVisible && iconPosition === ICON_POSITION.RIGHT && (
          <div className={`buttonNew_label__Wrapper ${buttonFlexJustify}`}>
            <div
              className={`buttonNew_label ${labelAnimationClass} ${labelSizeCss}`}
            >
              <span>{label}</span>
            </div>
            {newSvgComponent && (
              <div className="buttonNew_label_svg buttonNew_label_svg_der">
                {newSvgComponent}
              </div>
            )}
          </div>
        )}
        {!operationIsVisible && iconPosition === ICON_POSITION.LEFT && (
          <div className="buttonNew_label__Wrapper buttonNew_label__Wrapper--izq">
            <div
              className={`buttonNew_label ${labelAnimationClass} ${labelSizeCss}`}
            >
              <span>{label}</span>
            </div>
            {newSvgComponent && (
              <div className="buttonNew_label_svg buttonNew_label_svg_izq">
                {newSvgComponent}
              </div>
            )}
          </div>
        )}
        {operationIsVisible && (
          <Spin
            operation={operation}
            color={`${color}-${segment}`}
            size={mySize}
          />
        )}
      </span>
    );
  };

  renderButtonAndContent = (props) => {
    const {
      onClick,
      link,
      taggingInfo,
      disable,
      className,
      label,
      color,
      forceExternal,
      size,
      target,
      font,
      textTransform,
      buttonType,
      borderRadius,
      download,
      cySelector,
      hide,
    } = props;
    const segment = this.getSegment();

    /* check if size has w and  */
    const mySize = {
      w: BUTTON_WIDTH.MEDIUM,
      h: BUTTON_HEIGHT.REGULAR,
      ...size,
    };

    const customClassName = className ? `${className} ` : '';
    const colorCss = `buttonNew buttonNew--${color}-${segment} ${
      disable
        ? `buttonNew--${color}-${segment}--disable`
        : `buttonNew--${color}-${segment}--enable`
    }`;
    const customCss = `font_${segment}--${font} textTransform--${textTransform}`;
    const widthCss = this.buttonSizeCss(mySize, segment);
    const statusCss = `buttonNew_status--${disable ? 'disable' : 'enable'}`;
    const borderCss = `buttonNew_border-${borderRadius}`;

    /* COMPLETING TAGGINGINFO IF NEEDED */
    if (!taggingInfo.componentContent) {
      taggingInfo.componentContent = BUTTON_CONTENT.DEFAULT;
    }
    if (!taggingInfo.componentName) {
      taggingInfo.componentName = COMPONENT_NAME;
    }
    if(hide){
      return null;
    }
    return (
      <CustomLink
        taggingInfo={taggingInfo}
        link={link}
        ariaLabel={label}
        onClick={onClick}
        forceExternal={forceExternal}
        className={`button ${customClassName} ${colorCss} ${widthCss} ${statusCss} ${borderCss} ${customCss} ButtonCL`}
        target={target}
        buttonType={buttonType}
        disable={disable}
        download={download}
        cySelector={cySelector}
      >
        {this.renderButtonContent(props)}
      </CustomLink>
    );
  };

  render() {
    const myProps = setUpPropsByDevice(this.props);
    let { operation } = myProps;
    const { taggingInfo } = myProps;
    /* Cheeckings */
    let operationSendExist = false;
    BUTTON_OPERATION_KEYS.forEach((opKey) => {
      if (!operationSendExist && operation === BUTTON_OPERATION[opKey]) {
        operationSendExist = true;
      }
    });
    if (!operationSendExist) {
      warnLog(
        '[Button]: operation sended is not defined, prop has been reset to BUTTON_OPERATION.NO',
        'button-operation',
      );
      operation = BUTTON_OPERATION.NO;
    }
    if (!taggingInfo) {
      errorLog('[Button]: taggingInfo is not present');
      return null;
    }

    return this.renderButtonAndContent(myProps);
  }
}

Button.propTypes = {
  /**
   * {
   *  "info": "Texto que aparecerá dentro del componente",
   *  "kind": "both",
   *  "beautifulName": "Texto"
   * }
   */
  label: PropTypes.string,
  /**
   * {
   *  "info": "Tipo de botón, sirve para cumplimentar la propiedad type del dom para este elemento: submit, button o reset. Quedará anulada en caso de especificar un link.",
   *  "kind": "playground",
   *  "beautifulName": "Tipo"
   * }
   */
  buttonType: PropTypes.oneOf(['submit', 'button', 'reset']),
  /**
   * {
   *  "info": "Tipo de fuente del texto, por defecto es regular",
   *  "kind": "both",
   *  "beautifulName": "font"
   * }
   */
  font: PropTypes.oneOf(convertToOptions(BUTTON_FONT)),
  /**
   * {
   *  "info": "Tipo de transformación sobre el texto, por defecto initial",
   *  "kind": "both",
   *  "beautifulName": "textTransform"
   * }
   */
  textTransform: PropTypes.oneOf(convertToOptions(BUTTON_TEXT_TRANSFORM)),
  /**
   * {
   *  "info": "SVG del botón",
   *  "kind": "both",
   *  "beautifulName": "SVG"
   * }
   */
  svgComponent: PropTypes.node,
  /**
   * {
   *  "info": "Tema del botón, sirve para definir el tema del botón en el array BUTTON_COLOR",
   *  "kind": "both",
   *  "beautifulName": "Tema"
   * }
   */
  color: PropTypes.oneOf(convertToOptions(BUTTON_COLOR)),
  /**
   * {
   *  "info": "Permite definir si el botón está desactivado o no; en caso de desactivado el elemento cambiará de color y dejará de ser clicable",
   *  "kind": "both",
   *  "beautifulName": "Habilitado"
   * }
   */
  disable: PropTypes.bool,
  /**
   * {
   *  "info": "Permite definir el tamaño del label, en caso de ser incosistente con su size.h",
   *  "kind": "both",
   *  "beautifulName": "Habilitado"
   * }
   */
  labelSize: PropTypes.oneOf(convertToOptions(LABEL_SIZE)),
  /**
   * {
   *  "info": "Tamaño del botón, permite determinar el tamaño tanto en ancho como en alto {w: BUTTON_WIDTH..., h: BUTTON_HEIGHT...}",
   *  "kind": "both",
   *  "beautifulName": "Tamaño"
   * }
   */
  size: PropTypes.shape({
    /**
     * {
     *  "info": "Permite determinar el ancho del botón",
     *  "kind": "both",
     *  "beautifulName": "Ancho"
     * }
     */
    w: PropTypes.oneOf(convertToOptions(BUTTON_WIDTH)),
    /**
     * {
     *  "info": "Permite determinar la altura del botón",
     *  "kind": "both",
     *  "beautifulName": "Alto"
     * }
     */
    h: PropTypes.oneOf(convertToOptions(BUTTON_HEIGHT)),
  }),
  /**
   * {
   *  "info": "Permite establecer una animación en función de un estado a este componente, reflejando una operación de las definidas BUTTON_OPERATION",
   *  "kind": "both",
   *  "beautifulName": "Operacion"
   * }
   */
  operation: PropTypes.oneOf(convertToOptions(BUTTON_OPERATION)),
  /**
   * {
   *  "info": "Url a la que se accederá tras hacer click en el elemento si es que lo tuviese",
   *  "kind": "both",
   *  "beautifulName": "Enlace"
   * }
   */
  link: PropTypes.string,
  /**
   * {
   *  "info": "Función js que se ejecutará al hacer click, si es necesario",
   *  "kind": "playground",
   *  "beautifulName": "Funcion"
   * }
   */
  onClick: PropTypes.func,
  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: PropTypes.object.isRequired,
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: PropTypes.string,
  /**
   * {
   *  "info": "Define si el enlace se tiene que forzar a comportar como enlace externo",
   *  "kind": "playground",
   *  "beautifulName": "Enlace externo"
   * }
   */
  forceExternal: PropTypes.bool,
  /**
   * {
   *  "info": "Propiedades a aplicar para escritorio (sobreescribe las propiedades anteriores) ",
   *  "kind": "both",
   *  "beautifulName": "Escritorio"
   * }
   */
  desktopProps: PropTypes.object,
  /**
   * {
   *  "info": "Valor del target en caso de tener link",
   *  "kind": "both",
   *  "beautifulName": "Target"
   * }
   */
  target: PropTypes.oneOf(['_self', '_blank', 'parent', '_top']),
  /**
   * {
   *  "info": "Posicion del icono respecto al texto del botón",
   *  "kind": "both",
   *  "beautifulName": "Posición SVG"
   * }
   */
  iconPosition: PropTypes.oneOf(convertToOptions(ICON_POSITION)),
  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: PropTypes.oneOf(convertToOptions(SEGMENT)),
  /**
   * {
   *  "info": "Redondeado del borde",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  borderRadius: PropTypes.oneOf(convertToOptions(BORDER_RADIUS)),
  /**
   * {
   *  "info": "Establece el nombre al fichero recibido como link en caso de que se vaya a descargar",
   *  "kind": "both",
   *  "beautifulName": "Descargar"
   * }
   */
  download: PropTypes.string,
  /**
   * {
   *  "info": "Se añade selector cy-data",
   *  "kind": "both",
   *  "beautifulName": "Descargar"
   * }
   */
  cySelector: PropTypes.string,
};

Button.defaultProps = {
  label: '',
  buttonType: 'button',
  svgComponent: null,
  color: BUTTON_COLOR.BLUE,
  font: BUTTON_FONT.REGULAR_FONT,
  textTransform: BUTTON_TEXT_TRANSFORM.INITIAL,
  disable: false,
  labelSize: null,
  size: {
    w: BUTTON_WIDTH.MEDIUM,
    h: BUTTON_HEIGHT.REGULAR,
  },
  operation: BUTTON_OPERATION.NO,
  link: '',
  onClick: null,
  className: '',
  forceExternal: false,
  desktopProps: null,
  target: '_self',
  iconPosition: ICON_POSITION.RIGHT,
  segment: SEGMENT.GP,
  borderRadius: BORDER_RADIUS.SMALL,
  download: '',
  cySelector: '',
};

export default Button;
